module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-188.37a3933.woff2";